import { t } from '../../../common/components/T';
import Language from '../../../common/decorators/Language';
import ErrorPage from '../ErrorPage';

const NotFound = ({ translates }) => {
    return (
        <Language page={'/error'} translates={translates}>
            <ErrorPage
                failTests={false}
                translates={translates}
                title={t('error_title-404', 'Вы перешли по несуществующему адресу', '/error', translates)}
                imgPath={'/src/img/errors/error_404_gt.png'}
                subtitle={t(
                    'error_subtitle-404_gt',
                    'Пожалуйста, проверьте корректность ввода ссылки в адресной строке. Если возникнут трудности, наша служба поддержки рада помочь вам в их решении:',
                    '/error',
                    translates
                )}
                errorCode={404}
                supportLink
            />
        </Language>
    );
};
export default NotFound;
